import { render, staticRenderFns } from "./DiagnosticHealth.vue?vue&type=template&id=0e8c7d92&"
import script from "./DiagnosticHealth.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHealth.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticHealth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports